const routes = [
    {
        path: "/mentora/time/off/request-form",
        component: () => import("../pages/student/RequestForm.vue"),
        meta: {
            isAuthenticated: true,
            permission: "studenttimeoffrequest_studentform"
        }
    },
    {
        path: "/mentora/time/off/requests",
        component: () => import("../pages/admin/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "studenttimeoffrequest_index"
        }
    },
    {
        path: "/mentora/time/off/request-detail/:id",
        component: () => import("../pages/admin/Show.vue"),
        meta: {
            isAuthenticated: true,
            permission: "studenttimeoffrequest_show"
        }
    },
];

export default routes;
